import { render } from "./PersianDatePicker.vue?vue&type=template&id=36d9d097&ts=true"
import script from "./PersianDatePicker.vue?vue&type=script&lang=ts"
export * from "./PersianDatePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__